module.exports = __webpack_public_path__ + "img/b.6bde3510.jpg";